<template>
  <div class="statistics-form">
    <div class="a-vs-c--subtitle-teams">
      <div class="a-vs-footer--pair__host">
        <h3>{{ homeTeam }}</h3>
        <img :src="homeTeamLogo" :alt="homeTeamShort">
      </div>
      <span>{{$t('vs').toLowerCase()}}</span>

      <div class="a-vs-footer--pair__guest">
        <img :src="awayTeamLogo" :alt="awayTeamShort">
        <h3>{{ awayTeam }}</h3>
      </div>
    </div>
    <div class="a-vs-c--card-title">
      <h4>{{ componentTitle }}</h4>
      <p>{{ componentSubtitle }}</p>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    componentTitle: {
      type: String
    },
    componentSubtitle: {
      type: String
    },
    awayTeam: {
      type: String
    },
    awayTeamLogo: {
      type: String
    },
    awayTeamShort: {
      type: String
    },
    homeTeam: {
      type: String
    },
    homeTeamLogo: {
      type: String
    },
    homeTeamShort: {
      type: String
    }
  }
}
</script>
